import React, { memo, useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { ActionButtons, Title } from '../Utils/CustomClasses'
import PhotoApp from './PhotoApp'
import EditEmailApp from './EditEmailApp'
import EditProfileApp from './EditProfileApp'
import EditProfileStage2App from './EditProfileStage2App'
import ChooseSubscription from './ChooseSubscription'
import ChoosePaymentOption from './ChoosePaymentOption'
import FeeSubscriptionApp from './FeeSubscriptionApp'
import FeeCompletedApp from './FeeCompletedApp'
import EditPhoneNumberApp from './EditPhoneNumberApp'
import ProofIdentityApp from './ProofIdentityApp'
import styled from 'styled-components'

const OnboardingPanel = styled.div``

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: stretch;
  overflow: hidden;
  @media screen and (max-width: 700px) {
    flex-direction: column;
  }
`

const ActionPanel = styled.div`
  background-color: #ffffff;
  width: 100%;
`

const TitleBox = styled.div`
  background-color: #ff9900;
  display: flex;
  justify-content: space-between;
  padding: 7px 20px 7px 36px;

  @media (max-width: 767px) {
    padding: 7px 20px 7px 20px;
  }
`

const SplitColumn = styled.div`
  width: -webkit-fill-available;
`

const SplitColumnRight = styled(SplitColumn)`
  text-align: right;
  width: 33px;

  span {
    font-size: 18px;
  }
`

const CloseButton = styled(ActionButtons)`
  background-color: #a00d35;
  border: 1px solid #fff;
  color: #fff;
  display: block;
  padding: 0;
  margin: 0;
  width: 33px;
`

const TitleBoxBottom = styled.div`
  background-color: #734b0f;
  padding: 7px 10px 7px 36px;

  @media (max-width: 767px) {
    padding: 7px 10px 7px 20px;
  }
`

const MyFreebirdOnboardingPanel = memo(
  ({
    data,
    discountCode,
    pageText,
    user,
    step,
    countriesNice,
    onUpdate,
    onClose,
    isCopied,
    isCopiedInSubFormPanel,
    iAminSubscriptionFormPanel,
    setIAminSubscriptionFormPanel,
    setIsCopiedInSubFormPanel,
    setShowPopup,
    setClickedFeeLink,
    actionRef,
  }) => {
    const [actionTitle, setActionTitle] = useState('')
    const [chosenPanel, setChosenPanel] = useState('')

    useEffect(() => {
      setChosenTitle(step)
      setChosenPanel(step)
      //setChosenPanel('feestage2')
    }, [step, pageText])

    const progressSteps = {
      photo: 'photo',
      email: 'email',
      emailconf: 'emailconf',
      profile: 'profile',
      profilestage2: 'profilestage2',
      fee: 'fee',
      feestage2: 'feestage2',
      feestage3: 'feestage3',
      feestage4: 'feestage4',
      phone: 'phone',
      id: 'id',
      community: 'community',
    }

    const actionTitles = {
      photo: `${pageText[2]}`,
      email: `${pageText[3]}`,
      profile: `${pageText[4]}`,
      profilestage2: `${pageText[32]}`,
      fee: `${pageText[5]}`,
      feestage2: `${pageText[5]}`,
      feestage3: `${pageText[5]}`,
      feestage4: `${pageText[5]}`,
      phone: `${pageText[7]}`,
      id: `${pageText[8]}`,
    }

    const setChosenTitle = (item) => {
      var titleVal = ''
      switch (item) {
        case progressSteps.photo:
          titleVal = actionTitles.photo
          break
        case progressSteps.email:
          titleVal = actionTitles.email
          break
        case progressSteps.profile:
          titleVal = actionTitles.profile
          break
        case progressSteps.profilestage2:
          titleVal = actionTitles.profilestage2
          break
        case progressSteps.fee:
          titleVal = actionTitles.fee
          break
        case progressSteps.feestage2:
          titleVal = actionTitles.feestage2
          break
        case progressSteps.feestage3:
          titleVal = actionTitles.feestage3
          break
        case progressSteps.feestage4:
          titleVal = actionTitles.feestage4
          break
        case progressSteps.phone:
          titleVal = actionTitles.phone
          break
        case progressSteps.id:
          titleVal = actionTitles.id
          break
        default:
          break
      }
      setActionTitle(titleVal)
    }

    const choosePaymentStep1 = () => {
      setChosenPanel(progressSteps.fee)
      setChosenTitle(progressSteps.fee)
    }

    const choosePaymentStep2 = () => {
      setChosenPanel(progressSteps.feestage2)
      setChosenTitle(progressSteps.feestage2)
    }

    const choosePaymentStep3 = () => {
      setChosenPanel(progressSteps.feestage3)
      setChosenTitle(progressSteps.feestage3)
    }

    const choosePaymentStep4 = () => {
      setChosenPanel(progressSteps.feestage4)
      setChosenTitle(progressSteps.feestage4)
    }

    if (!user) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ margin: '100px auto 100px', opacity: '0.3' }}
            role="status"
          ></div>
        </div>
      )
    }
    return (
      <OnboardingPanel>
        {' '}
        {chosenPanel !== progressSteps.community && (
          <FlexRow>
            <ActionPanel>
              <TitleBox>
                <SplitColumn>
                  <Title
                    color="#fff"
                    size="22px"
                    sizemd="22px"
                    sizesm="22px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${actionTitle}`,
                    }}
                  ></Title>
                </SplitColumn>
                <SplitColumnRight>
                  <CloseButton
                    color="#fff"
                    type="submit"
                    fontsizesm="16px"
                    onClick={(e) => onClose(e)}
                  >
                    X
                  </CloseButton>
                </SplitColumnRight>
              </TitleBox>

              {chosenPanel == progressSteps.photo ? (
                <PhotoApp data={data} onUpdate={onUpdate} />
              ) : chosenPanel == progressSteps.email ? (
                <EditEmailApp data={data} onUpdate={onUpdate} />
              ) : chosenPanel == progressSteps.profile ? (
                <EditProfileApp
                  data={data}
                  countriesNice={countriesNice}
                  onUpdate={onUpdate}
                />
              ) : chosenPanel == progressSteps.profilestage2 ? (
                <EditProfileStage2App data={data} onUpdate={onUpdate} />
              ) : chosenPanel == progressSteps.fee ? (
                <ChooseSubscription
                  data={data}
                  onUpdate={choosePaymentStep2}
                  actionRef={actionRef}
                />
              ) : chosenPanel == progressSteps.feestage2 ? (
                <ChoosePaymentOption
                  actionRef={actionRef}
                  setShowPopup={setShowPopup}
                  setClickedFeeLink={setClickedFeeLink}
                  isCopied={isCopied}
                  dCode={discountCode}
                  data={data}
                  onUpdate={choosePaymentStep3}
                  onBack={choosePaymentStep1}
                />
              ) : chosenPanel == progressSteps.feestage3 ? (
                <FeeSubscriptionApp
                  actionRef={actionRef}
                  isCopiedInSubFormPanel={isCopiedInSubFormPanel}
                  setIsCopiedInSubFormPanel={setIsCopiedInSubFormPanel}
                  iAminSubscriptionFormPanel={iAminSubscriptionFormPanel}
                  setIAminSubscriptionFormPanel={setIAminSubscriptionFormPanel}
                  data={data}
                  onUpdate={choosePaymentStep4}
                  onBack={choosePaymentStep2}
                />
              ) : chosenPanel == progressSteps.feestage4 ? (
                <FeeCompletedApp
                  actionRef={actionRef}
                  data={data}
                  onUpdate={onUpdate}
                />
              ) : chosenPanel == progressSteps.phone ? (
                <EditPhoneNumberApp
                  data={data}
                  search={data.search}
                  onUpdate={onUpdate}
                />
              ) : chosenPanel == progressSteps.id ? (
                <ProofIdentityApp data={data} onUpdate={onUpdate} />
              ) : null}
              <TitleBoxBottom></TitleBoxBottom>
            </ActionPanel>
          </FlexRow>
        )}
      </OnboardingPanel>
    )
  }
)

export default withRouter(MyFreebirdOnboardingPanel)
